var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"svg-icon",class:`svg-icon-${_vm.className}`},[_c('inline-svg',{attrs:{"src":`/media/svg/icons/Neolex/Basic/${_vm.isChecked}.svg`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }